<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="isModalOpen" class="fixed top-0 left-0 p-15 w-full h-full bg-backdrop flex justify-center items-center z-100"
           @click.self="close"
      >
        <div class="relative bg-primary max-w-420 w-full rounded-4 pl-20 pt-20 pr-16 pb-12">
          <div class="text-app-color">
            <p class="text-22 font-black">{{ title }}</p>
            <slot />
          </div>
          <div class="flex justify-end items-center">
            <ButtonModule
              :has-hover="true"
              :text="confirmBtnCancel"
              class="text-app-color text-15 mr-12"
              @click="close"
            />
            <ButtonModule
              :text="confirmBtnTitle"
              :class="confirmBtnClass"
              class="rounded-4 px-35 py-12 text-white text-15"
              @click="confirm"
            />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { defineComponent, ref } from 'vue'

import { preventBodyScroll } from '@/core/helper-functions'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

export default defineComponent({
  components: { ButtonModule },

  props: {
    confirmBtnTitle: {
      type: String,
      default: ''
    },
    confirmBtnCancel: {
      type: String,
      default: 'Cancel'
    },
    confirmBtnClass: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },

  emits: ['confirm'],

  setup (_, { emit }) {
    const isModalOpen = ref(false)

    function open () {
      preventBodyScroll(true)
      isModalOpen.value = true
    }

    function close () {
      preventBodyScroll(false)
      isModalOpen.value = false
    }

    function confirm () {
      emit('confirm')
    }

    return {
      // ref
      isModalOpen,
      // function
      open,
      close,
      confirm
    }
  }
})
</script>
